import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowsShrinkVIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M13.79 10.21a.9997.9997 0 0 0 1.42 0 .9994.9994 0 0 0 .2189-1.0946A1.001 1.001 0 0 0 15.21 8.79l-2.5-2.5a.9994.9994 0 0 0-.33-.21 1 1 0 0 0-.76 0 .9994.9994 0 0 0-.33.21l-2.5 2.5a1.0041 1.0041 0 0 0 1.42 1.42l.79-.8v5.18l-.79-.8a1.0041 1.0041 0 1 0-1.42 1.42l2.5 2.5c.0951.091.2072.1624.33.21a.94.94 0 0 0 .76 0 1.0002 1.0002 0 0 0 .33-.21l2.5-2.5a1.0041 1.0041 0 1 0-1.42-1.42l-.79.8V9.41l.79.8ZM7 4h10a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2Zm10 16H7a1.0002 1.0002 0 0 0-.7071 1.7071C6.4804 21.8946 6.7348 22 7 22h10a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineArrowsShrinkVIcon
